<template><svg xmlns="http://www.w3.org/2000/svg" width="36.029" height="36.029" viewBox="0 0 36.029 36.029">
    <g transform="translate(-11.204 1)">
        <g transform="translate(12.204)">
            <g transform="translate(0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                <path d="M312.005,243.975v-.431a4.537,4.537,0,1,1,9.074,0v.431"
                      transform="translate(-299.528 -221.993)"/>
                <path d="M318.41,232.257l-3.4,10.209" transform="translate(-297.989 -225.451)"/>
                <path d="M309.574,234.507a.567.567,0,1,0,.567.567.567.567,0,0,0-.567-.567h0"
                      transform="translate(-301.064 -224.298)"/>
                <path d="M322.324,238.257a.567.567,0,1,0,.567.567.567.567,0,0,0-.567-.567h0"
                      transform="translate(-294.531 -222.377)"/>
                <path d="M320.825,234.507a.567.567,0,1,0,.564.567.567.567,0,0,0-.564-.567h0"
                      transform="translate(-295.301 -224.298)"/>
                <path d="M312.574,231.507a.567.567,0,1,0,.567.567.567.567,0,0,0-.567-.567h0"
                      transform="translate(-299.527 -225.835)"/>
                <path d="M334.1,246.748a23.825,23.825,0,0,0-28.527,0"
                      transform="translate(-302.823 -220.455)"/>
                <path d="M320.77,261.786a17.014,17.014,0,1,0-17.014-17.015A17.015,17.015,0,0,0,320.77,261.786Z"
                      transform="translate(-303.755 -227.757)"/>
                <path d="M308.074,238.257a.567.567,0,1,0,.567.567.567.567,0,0,0-.567-.567"
                      transform="translate(-301.832 -222.377)"/>
            </g>
        </g>
    </g>
</svg>
</template>